import { API } from '@Providers';

export default async function () {
  const endpoint = '/api/shelter/cash-drawer/get-cash-drawer-options';

  return API({ endpoint });
}
